import { useQuery } from '@apollo/client'
import { GET_GAME_OBJECTS } from '../../services/queries'
import isEqual from 'lodash/isEqual'
import l10n from '../../components/i18n/I18N'
import { useStateValue } from '../../services/state/StateProvider'

const useGetGames = () => {
  const [{ casino }, dispatch] = useStateValue()

  const updateCasinoGames = data => {
    const fullGameList = data.entries
    let games = {}
    
    if (fullGameList && fullGameList.length > 0) {
      for (let i = 0; i < fullGameList.length; i++) {
        games[fullGameList[i].id] = fullGameList[i]
      }

      if (!isEqual(games, casino.games)) {
        console.log('[Casino] update full games list')
        dispatch({
          type: 'addGames',
          casino: {
            games: games
          }
        })
      }
    }
  }

  useQuery(GET_GAME_OBJECTS, {
    variables: {
      section: 'games',
      site: l10n.site,
      gameId: null
    },
    onCompleted: updateCasinoGames,
    onError: error => console.log('[useGetGames]', error)
  })
}

export { useGetGames }
